<template>
    <v-container fluid grid-list-lg>
        <h1 class="display-3">Codificación</h1>
        <br>
        <v-layout row wrap>
            <v-flex x12 sm12 md6>
                <v-text-field label="Código" v-model="codigo" @change="panDecodifica()" clearable></v-text-field>
            </v-flex>
            <v-flex x12 sm12 md6>
                <v-text-field label="Descripción" v-model="descripcion" @input="panDecodifica()" counter></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm12 md3>
                <v-list two-line>
                    <v-subheader>GENERAL</v-subheader>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-select clearable
                                      @input="filtro()"
                                      :items="tipos_item"
                                      v-model="tipo_item"
                                      label="Tipo de item"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-select clearable
                                      @input="filtro()"
                                      :items="tiposList"
                                      v-model="d.tipo"
                                      label="Tipo"
                                      item-text="desc"
                                      item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pue'">
                        <v-list-tile-content>
                            <v-text-field clearable @input="filtro()" v-model="d.alto" label="Alto"></v-text-field>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pue'">
                        <v-list-tile-content>
                            <v-text-field clearable @input="filtro()" v-model="d.ancho" label="Ancho"></v-text-field>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pan' || tipo_item === 'pue'">
                        <v-list-tile-content>
                            <v-select clearable @input="filtro()" :items="nucleos" v-model="d.nucleo" label="Núcleo"
                                      item-text="desc" item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pan' || tipo_item === 'pue'">
                        <v-list-tile-content>
                            <v-select clearable @input="filtro()" :items="esps" v-model="d.esp" label="Espesor"
                                      item-text="desc" item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pan'">
                        <v-list-tile-content>
                            <v-select clearable @input="filtro()" :items="denss" v-model="d.dens" label="Densidad"
                                      item-text="desc" item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
            <v-flex xs12 sm12 md3 v-if="tipo_item === 'equ'">
                <v-list two-line>
                    <v-list two-line>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-select clearable
                                          :items="alims"
                                          v-model="d.alim"
                                          label="Alimentación"
                                          @input="filtro()"
                                          item-text="desc"
                                          item-value="variable"></v-select>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-select clearable
                                          :items="temps"
                                          v-model="d.temp"
                                          label="Temperatura"
                                          @input="filtro()"
                                          item-text="desc"
                                          item-value="variable"></v-select>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-select clearable
                                          :items="modelos"
                                          v-model="d.modelo"
                                          label="Modelo"
                                          @input="filtro()"
                                          item-text="desc"
                                          item-value="variable"></v-select>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-list>
            </v-flex>
            <v-flex xs12 sm12 md3 v-if="tipo_item === 'equ'">
                <v-list two-line>
                    <v-list two-line>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-select clearable
                                          :items="comandos"
                                          v-model="d.comando"
                                          label="Comando"
                                          @input="filtro()"
                                          item-text="desc"
                                          item-value="variable"></v-select>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-select clearable
                                          :items="kits"
                                          v-model="d.kit"
                                          label="Kit"
                                          @input="filtro()"
                                          item-text="desc"
                                          item-value="variable"></v-select>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-select clearable
                                          :items="muros"
                                          v-model="d.muro"
                                          label="Muro"
                                          @input="filtro()"
                                          item-text="desc"
                                          item-value="variable"></v-select>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-list>
            </v-flex>
            <v-flex xs12 sm12 md3 v-if="tipo_item === 'pan' || tipo_item === 'pue'">
                <v-list two-line>
                    <v-subheader>EXTERIOR</v-subheader>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-select clearable
                                      @change="filtro()"
                                      :items="ext_revs"
                                      v-model="d.ext_rev"
                                      label="Revesitmiento"
                                      item-text="desc"
                                      item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <color label="Color" v-model="d.ext_col" :items="ext_cols" @actualiza="filtro()"></color>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pan'">
                        <v-list-tile-content>
                            <v-select clearable
                                      @input="filtro()" :items="ext_esps" v-model="d.ext_esp" label="Espesor"
                                      item-text="desc" item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pan'">
                        <v-list-tile-content>
                            <terminacion label="Terminación" v-model="d.ext_term" :items="ext_terms"
                                         @actualiza="filtro()"></terminacion>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
            <v-flex xs12 sm12 md3 v-if="tipo_item === 'pan' || tipo_item === 'pue'">
                <v-list two-line>
                    <v-subheader>INTERIOR</v-subheader>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-select clearable @input="filtro()" :items="int_revs" v-model="d.int_rev"
                                      label="Revesitmiento" item-text="desc" item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <color label="Color" v-model="d.int_col" :items="int_cols" @actualiza="filtro()"></color>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pan'">
                        <v-list-tile-content>
                            <v-select clearable @input="filtro()" :items="int_esps" v-model="d.int_esp" label="Espesor"
                                      item-text="desc" item-value="variable"></v-select>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="tipo_item === 'pan'">
                        <v-list-tile-content>
                            <terminacion label="Terminación" v-model="d.int_term" :items="int_terms"
                                         @actualiza="filtro()"></terminacion>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
            <v-flex xs12 sm12 md3>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <v-list two-line dense>
                    <v-subheader>TOTAL EXISTENTE {{ tot }}</v-subheader>
                    <div class="lista-cont scroll-style">
                        <template v-for="f in filtros">
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ f.B1_COD }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ f.B1_DESC }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </div>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import color from '../../components/SelectColor';
    import terminacion from '../../components/SelectTerminacion';

    export default {
        components: {color, terminacion},
        data() {
            return {
                loading: false,
                descripcion: "",
                codigo: "",
                filtros: [],
                tot: 0,
                tipo_item: 'pan',
                tipos_item: [
                    {value: 'pan', text: 'PANEL'},
                    {value: 'pue', text: 'PUERTA'},
                    {value: 'equ', text: 'EQUIPO'},
                ],
                d: {
                    tipo: "",
                    ext_rev: "",
                    ext_col: "",
                    ext_esp: "",
                    ext_term: "",
                    int_rev: "",
                    int_col: "",
                    int_esp: "",
                    int_term: "",
                    dens: "",
                    nucleo: "",
                    esp: "",
                    alto: "",
                    ancho: "",
                    temp: "",
                    modelo: "",
                    alim: "",
                    comando: "",
                    kit: "",
                    muro: "",
                },
                nucleos: [],
                tipos: [],
                esps: [],
                denss: [],
                int_revs: [],
                int_cols: [],
                int_esps: [],
                int_terms: [],
                ext_revs: [],
                ext_cols: [],
                ext_esps: [],
                ext_terms: [],
                temps: [],
                modelos: [],
                alims: [],
                comandos: [],
                kits: [],
                muros: [],
                posiciones: []
            };
        },
        computed: {
            tiposList() {
                return this.tipos.filter(i => i.tipo_item === this.tipo_item)
            }
        },
        mounted() {
            this.listado();
        },
        methods: {
            listado() {
                this.$http.post("panel/listado")
                    .then(r => {
                        let cod = r.data.codigo;
                        this.posiciones = r.data.posiciones;
                        this.nucleos = cod.nucleo;
                        this.tipos = cod.tipo;
                        this.esps = cod.esp;
                        this.denss = cod.densidad;
                        this.int_revs = cod.rev;
                        this.int_cols = cod.col;
                        this.int_esps = cod.esp_cara;
                        this.int_terms = cod.term;
                        this.ext_revs = cod.rev;
                        this.ext_cols = cod.col;
                        this.ext_esps = cod.esp_cara;
                        this.ext_terms = cod.term;
                        this.temps = cod.temp;
                        this.modelos = cod.modelo;
                        this.alims = cod.alim;
                        this.comandos = cod.comando;
                        this.kits = cod.kit;
                        this.muros = cod.muro;
                    });
            },
            equGeneraTxt() {
                this.descripcion = (this.tipo_item) ? this.tipos_item.find(r => r.value === this.tipo_item).text : '';
                this.descripcion += ' ';
                this.descripcion += (this.d.tipo) ? this.tipos.find(r => r.variable === this.d.tipo).desc : '';
                this.descripcion += ' ';
                this.descripcion += (this.d.alim) ? this.alims.find(r => r.variable === this.d.alim).desc : '';
                this.descripcion += ' ';
                this.descripcion += (this.d.temp) ? this.d.temp : '';
                this.descripcion += (this.d.temp) ? 'T ' : '';
                this.descripcion += (this.d.modelo) ? this.modelos.find(r => r.variable === this.d.modelo).desc : '';
                this.descripcion += (this.d.comando) ? ' C' : '';
                this.descripcion += (this.d.comando) ? this.comandos.find(r => r.variable === this.d.comando).desc : '';
                this.descripcion += (this.d.kit) ? ' K' : '';
                this.descripcion += (this.d.kit) ? this.kits.find(r => r.variable === this.d.kit).desc : '';
                this.descripcion += (this.d.muro) ? ' M' : '';
                this.descripcion += (this.d.muro) ? this.muros.find(r => r.variable === this.d.muro).desc : '';
            },
            panGeneraTxt() {
                this.descripcion = (this.tipo_item) ? this.tipos_item.find(r => r.value === this.tipo_item).text : '';
                this.descripcion += ' ';
                this.descripcion += (this.d.tipo) ? this.tipos.find(r => r.variable === this.d.tipo).desc : '';
                this.descripcion += (this.d.alto) ? ' ' + this.d.alto : '';
                this.descripcion += (this.d.ancho) ? 'X' + this.d.ancho : '';
                this.descripcion +=
                    " " +
                    this.d.ext_rev +
                    this.d.ext_col +
                    this.d.ext_esp +
                    this.d.ext_term +
                    "/";
                this.descripcion += this.d.int_rev + this.d.int_col + this.d.int_esp + this.d.int_term;

                let nucleo = this.nucleos.find(r => (r.variable === this.d.nucleo) ? r.desc : '');
                let esp = this.esps.find(r => (r.variable === this.d.esp) ? r.desc : '');
                nucleo = (nucleo) ? nucleo.desc : '';
                esp = (esp) ? esp.desc : '';
                this.descripcion += " " + nucleo + " " + esp;
            },
            panDecodifica() {
                if (this.codigo.length < 2) {
                    return false;
                }
                let cod = this.codigo.toUpperCase();
                let tipoCod = cod.substring(0, 2);
                let tipoObj = this.tipos.find(r => {
                    return r.variable === tipoCod;
                });
                this.tipo_item = tipoObj.tipo_item;
                if (!this.tipo_item) {
                    return false;
                }

                this.posiciones[this.tipo_item].forEach(r => {
                    let valor = cod.substring(r.desde, r.desde + r.cant);
                    if (r.seccion === 'alto' || r.seccion === 'ancho') {
                        valor = valor / 100;
                    }
                    this.d[r.seccion] = valor;

                });
                this.panGeneraTxt();
                this.filtro();
            },
            panCodifica() {
                let alto = '';
                let ancho = '';
                if (this.d.alto && this.tipo_item === 'pue') {
                    let num = this.d.alto * 100;
                    let txt = num.toFixed(0);
                    alto = String('000' + txt).slice(-3);
                }
                if (this.d.ancho && this.tipo_item === 'pue') {
                    let num = this.d.ancho * 100;
                    let txt = num.toFixed(0);
                    ancho = String('000' + txt).slice(-3);
                }
                this.codigo =
                    this.d.tipo +
                    alto +
                    ancho +
                    this.d.ext_rev +
                    this.d.ext_col +
                    this.d.ext_esp +
                    this.d.ext_term +
                    this.d.int_rev +
                    this.d.int_col +
                    this.d.int_esp +
                    this.d.int_term +
                    this.d.dens +
                    this.d.nucleo +
                    this.d.esp;
            },
            equCodifica() {
                this.codigo = this.d.tipo + this.d.alim + this.d.temp + this.d.modelo + this.d.comando + this.d.kit + this.d.muro
            },
            filtro() {
                if (this.tipo_item === 'pan' || this.tipo_item === 'pue') {
                    this.panCodifica();
                    this.panGeneraTxt();
                    this.loading = true;
                    this.$http.post("panel/filtro", this.d).then(
                        r => {
                            this.filtros = r.data.result;
                            this.tot = r.data.tot;
                            this.loading = false;
                        },
                        err => {
                            this.loading = false;
                        }
                    );
                } else if (this.tipo_item === 'equ') {
                    this.equCodifica();
                    this.equGeneraTxt();
                }

            }
        }
    };
</script>
<style scoped>
    .lista-cont {
        max-height: 400px;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/utiles/codificacion.vue